import React from 'react';

const Spinner = () => <div className="loading-spinner" />;

export default Spinner;
